"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _core = _interopRequireDefault(require("../../utils/core"));

var _jquery = _interopRequireDefault(require("jquery"));

var _eventDispatcher = _interopRequireDefault(require("../../utils/eventDispatcher"));

require("../select");

var Toolbar = _core["default"].Class.extend({
  constructor: function constructor(plugin, toolbarOptions) {
    this.plugin = plugin;
    this.toolbarOptions = toolbarOptions;
  },
  render: function render() {
    var p = this.plugin,
        $toolbar = (0, _jquery["default"])('<div>').addClass('toolbar');

    if (this.toolbarOptions) {
      if (this.toolbarOptions.refresh) {
        var $refresh = (0, _jquery["default"])('<div>').addClass('component');
        $refresh.append((0, _jquery["default"])('<button>').addClass('webf-button webf-button-outline-dark refresh').append((0, _jquery["default"])('<i>').addClass('fas fa-sync')));
        $toolbar.append($refresh);
      }

      if (this.toolbarOptions.search) {
        var $search = (0, _jquery["default"])('<div>').addClass('component search').append((0, _jquery["default"])("<input type='text' autocomplete='off'>")).append((0, _jquery["default"])('<div>').addClass('webf-button white btn-search').text(p._('Rechercher')));
        $toolbar.append($search);
      }

      if (this.toolbarOptions.selectColumns) {
        var $selectColumnsComponent = (0, _jquery["default"])('<div>').addClass('component');
        var columns = this.plugin.getAllColumns();
        var $selectColumns = (0, _jquery["default"])('<select class="selectColumns" multiple></select>').on('change', function () {
          _eventDispatcher["default"].dispatch('datagrid.updateSelectColumns.' + p.hash, (0, _jquery["default"])(this).webfSelect('val'));
        });

        _core["default"].each(columns, function (i, column) {
          var caption = column.caption ? column.caption : p.translate('abbrColumn') + (i + 1);
          var $optionColumn = (0, _jquery["default"])('<option value="' + column.field + '">' + caption + '</option>');
          $optionColumn.prop('disabled', !column.caption);
          $optionColumn.prop('selected', _core["default"].isUndefined(column.visible) || column.visible);

          if (column.group) {
            var $group = $selectColumns.children('optgroup[label="' + column.group + '"]');

            if (!$group[0]) {
              $group = (0, _jquery["default"])('<optgroup label="' + column.group + '">');
              $selectColumns.append($group);
            }

            $group.append($optionColumn);
          } else {
            $selectColumns.append($optionColumn);
          }
        });

        $selectColumnsComponent.append($selectColumns);
        $toolbar.append($selectColumnsComponent);
        setTimeout(function () {
          $selectColumns.webfSelect({
            behavior: 'checkable',
            checkAllItem: {
              label: p.translate('allColumns')
            }
          });
        }, 10);
      }
    } else {
      $toolbar.addClass('hidden');
    }

    this.$toolbar = $toolbar;
    return $toolbar;
  },
  bindEvents: function bindEvents() {
    var self = this,
        p = this.plugin;

    this.plugin._on(this.$toolbar, '.refresh', {
      click: function click(ev) {
        ev.preventDefault();
        p.refresh();
      }
    });

    this.plugin._on(this.$toolbar, '.search .btn-search', {
      click: function click(ev) {
        ev.preventDefault();
        var $component = (0, _jquery["default"])(this).closest('.component');
        p.search($component.find("input[type='text']").val());
      }
    });

    this.plugin._on(this.$toolbar, ".search input[type='text']", {
      keydown: function keydown(ev) {
        if (ev.which == 13) {
          ev.preventDefault();
          p.search((0, _jquery["default"])(this).val());
        }
      }
    });
  }
});

var _default = Toolbar;
exports["default"] = _default;